/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AccessStatsResponseDto } from '../models/access-stats-response-dto';
import { documentAccessLogControllerGetAccessStats } from '../fn/document-access-logs/document-access-log-controller-get-access-stats';
import { DocumentAccessLogControllerGetAccessStats$Params } from '../fn/document-access-logs/document-access-log-controller-get-access-stats';
import { documentAccessLogControllerGetAuditTrail } from '../fn/document-access-logs/document-access-log-controller-get-audit-trail';
import { DocumentAccessLogControllerGetAuditTrail$Params } from '../fn/document-access-logs/document-access-log-controller-get-audit-trail';
import { documentAccessLogControllerGetDocumentAccessLogs } from '../fn/document-access-logs/document-access-log-controller-get-document-access-logs';
import { DocumentAccessLogControllerGetDocumentAccessLogs$Params } from '../fn/document-access-logs/document-access-log-controller-get-document-access-logs';
import { documentAccessLogControllerGetPatientAccessLogs } from '../fn/document-access-logs/document-access-log-controller-get-patient-access-logs';
import { DocumentAccessLogControllerGetPatientAccessLogs$Params } from '../fn/document-access-logs/document-access-log-controller-get-patient-access-logs';
import { documentAccessLogControllerGetRecentAccessLogs } from '../fn/document-access-logs/document-access-log-controller-get-recent-access-logs';
import { DocumentAccessLogControllerGetRecentAccessLogs$Params } from '../fn/document-access-logs/document-access-log-controller-get-recent-access-logs';
import { documentAccessLogControllerGetUserAccessLogs } from '../fn/document-access-logs/document-access-log-controller-get-user-access-logs';
import { DocumentAccessLogControllerGetUserAccessLogs$Params } from '../fn/document-access-logs/document-access-log-controller-get-user-access-logs';
import { documentAccessLogControllerGetUserRoleAccessLogs } from '../fn/document-access-logs/document-access-log-controller-get-user-role-access-logs';
import { DocumentAccessLogControllerGetUserRoleAccessLogs$Params } from '../fn/document-access-logs/document-access-log-controller-get-user-role-access-logs';
import { documentAccessLogControllerLogDocumentDownload } from '../fn/document-access-logs/document-access-log-controller-log-document-download';
import { DocumentAccessLogControllerLogDocumentDownload$Params } from '../fn/document-access-logs/document-access-log-controller-log-document-download';
import { documentAccessLogControllerLogDocumentView } from '../fn/document-access-logs/document-access-log-controller-log-document-view';
import { DocumentAccessLogControllerLogDocumentView$Params } from '../fn/document-access-logs/document-access-log-controller-log-document-view';
import { DocumentAccessLogResponseDto } from '../models/document-access-log-response-dto';
import { LogAccessResponseDto } from '../models/log-access-response-dto';

@Injectable({ providedIn: 'root' })
export class DocumentAccessLogsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentAccessLogControllerLogDocumentView()` */
  static readonly DocumentAccessLogControllerLogDocumentViewPath = '/thalea-documents/access-logs/{tenant}/documents/{documentId}/view';

  /**
   * Log document view access.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerLogDocumentView()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAccessLogControllerLogDocumentView$Response(params: DocumentAccessLogControllerLogDocumentView$Params, context?: HttpContext): Observable<StrictHttpResponse<LogAccessResponseDto>> {
    return documentAccessLogControllerLogDocumentView(this.http, this.rootUrl, params, context);
  }

  /**
   * Log document view access.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerLogDocumentView$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAccessLogControllerLogDocumentView(params: DocumentAccessLogControllerLogDocumentView$Params, context?: HttpContext): Observable<LogAccessResponseDto> {
    return this.documentAccessLogControllerLogDocumentView$Response(params, context).pipe(
      map((r: StrictHttpResponse<LogAccessResponseDto>): LogAccessResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAccessLogControllerLogDocumentDownload()` */
  static readonly DocumentAccessLogControllerLogDocumentDownloadPath = '/thalea-documents/access-logs/{tenant}/documents/{documentId}/download';

  /**
   * Log document download access.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerLogDocumentDownload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAccessLogControllerLogDocumentDownload$Response(params: DocumentAccessLogControllerLogDocumentDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<LogAccessResponseDto>> {
    return documentAccessLogControllerLogDocumentDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * Log document download access.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerLogDocumentDownload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAccessLogControllerLogDocumentDownload(params: DocumentAccessLogControllerLogDocumentDownload$Params, context?: HttpContext): Observable<LogAccessResponseDto> {
    return this.documentAccessLogControllerLogDocumentDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<LogAccessResponseDto>): LogAccessResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAccessLogControllerGetDocumentAccessLogs()` */
  static readonly DocumentAccessLogControllerGetDocumentAccessLogsPath = '/thalea-documents/access-logs/{tenant}/documents/{documentId}/logs';

  /**
   * Get access logs for a document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerGetDocumentAccessLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetDocumentAccessLogs$Response(params: DocumentAccessLogControllerGetDocumentAccessLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
    return documentAccessLogControllerGetDocumentAccessLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Get access logs for a document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerGetDocumentAccessLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetDocumentAccessLogs(params: DocumentAccessLogControllerGetDocumentAccessLogs$Params, context?: HttpContext): Observable<Array<DocumentAccessLogResponseDto>> {
    return this.documentAccessLogControllerGetDocumentAccessLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentAccessLogResponseDto>>): Array<DocumentAccessLogResponseDto> => r.body)
    );
  }

  /** Path part for operation `documentAccessLogControllerGetPatientAccessLogs()` */
  static readonly DocumentAccessLogControllerGetPatientAccessLogsPath = '/thalea-documents/access-logs/{tenant}/patients/{patientId}/logs';

  /**
   * Get access logs for a patient.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerGetPatientAccessLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetPatientAccessLogs$Response(params: DocumentAccessLogControllerGetPatientAccessLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
    return documentAccessLogControllerGetPatientAccessLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Get access logs for a patient.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerGetPatientAccessLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetPatientAccessLogs(params: DocumentAccessLogControllerGetPatientAccessLogs$Params, context?: HttpContext): Observable<Array<DocumentAccessLogResponseDto>> {
    return this.documentAccessLogControllerGetPatientAccessLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentAccessLogResponseDto>>): Array<DocumentAccessLogResponseDto> => r.body)
    );
  }

  /** Path part for operation `documentAccessLogControllerGetUserAccessLogs()` */
  static readonly DocumentAccessLogControllerGetUserAccessLogsPath = '/thalea-documents/access-logs/{tenant}/users/{userId}/logs';

  /**
   * Get access logs for a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerGetUserAccessLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetUserAccessLogs$Response(params: DocumentAccessLogControllerGetUserAccessLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
    return documentAccessLogControllerGetUserAccessLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Get access logs for a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerGetUserAccessLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetUserAccessLogs(params: DocumentAccessLogControllerGetUserAccessLogs$Params, context?: HttpContext): Observable<Array<DocumentAccessLogResponseDto>> {
    return this.documentAccessLogControllerGetUserAccessLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentAccessLogResponseDto>>): Array<DocumentAccessLogResponseDto> => r.body)
    );
  }

  /** Path part for operation `documentAccessLogControllerGetUserRoleAccessLogs()` */
  static readonly DocumentAccessLogControllerGetUserRoleAccessLogsPath = '/thalea-documents/access-logs/{tenant}/roles/{userRole}/logs';

  /**
   * Get access logs for a user role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerGetUserRoleAccessLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetUserRoleAccessLogs$Response(params: DocumentAccessLogControllerGetUserRoleAccessLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
    return documentAccessLogControllerGetUserRoleAccessLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Get access logs for a user role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerGetUserRoleAccessLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetUserRoleAccessLogs(params: DocumentAccessLogControllerGetUserRoleAccessLogs$Params, context?: HttpContext): Observable<Array<DocumentAccessLogResponseDto>> {
    return this.documentAccessLogControllerGetUserRoleAccessLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentAccessLogResponseDto>>): Array<DocumentAccessLogResponseDto> => r.body)
    );
  }

  /** Path part for operation `documentAccessLogControllerGetRecentAccessLogs()` */
  static readonly DocumentAccessLogControllerGetRecentAccessLogsPath = '/thalea-documents/access-logs/{tenant}/recent';

  /**
   * Get recent access logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerGetRecentAccessLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetRecentAccessLogs$Response(params: DocumentAccessLogControllerGetRecentAccessLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
    return documentAccessLogControllerGetRecentAccessLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Get recent access logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerGetRecentAccessLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetRecentAccessLogs(params: DocumentAccessLogControllerGetRecentAccessLogs$Params, context?: HttpContext): Observable<Array<DocumentAccessLogResponseDto>> {
    return this.documentAccessLogControllerGetRecentAccessLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentAccessLogResponseDto>>): Array<DocumentAccessLogResponseDto> => r.body)
    );
  }

  /** Path part for operation `documentAccessLogControllerGetAccessStats()` */
  static readonly DocumentAccessLogControllerGetAccessStatsPath = '/thalea-documents/access-logs/{tenant}/stats';

  /**
   * Get access statistics.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerGetAccessStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetAccessStats$Response(params: DocumentAccessLogControllerGetAccessStats$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessStatsResponseDto>> {
    return documentAccessLogControllerGetAccessStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get access statistics.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerGetAccessStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetAccessStats(params: DocumentAccessLogControllerGetAccessStats$Params, context?: HttpContext): Observable<AccessStatsResponseDto> {
    return this.documentAccessLogControllerGetAccessStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccessStatsResponseDto>): AccessStatsResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAccessLogControllerGetAuditTrail()` */
  static readonly DocumentAccessLogControllerGetAuditTrailPath = '/thalea-documents/access-logs/{tenant}/audit';

  /**
   * Get audit trail for compliance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAccessLogControllerGetAuditTrail()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetAuditTrail$Response(params: DocumentAccessLogControllerGetAuditTrail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
    return documentAccessLogControllerGetAuditTrail(this.http, this.rootUrl, params, context);
  }

  /**
   * Get audit trail for compliance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAccessLogControllerGetAuditTrail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentAccessLogControllerGetAuditTrail(params: DocumentAccessLogControllerGetAuditTrail$Params, context?: HttpContext): Observable<Array<DocumentAccessLogResponseDto>> {
    return this.documentAccessLogControllerGetAuditTrail$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentAccessLogResponseDto>>): Array<DocumentAccessLogResponseDto> => r.body)
    );
  }

}
